<template>
  <b-row>
    <b-col cosl="12">
      <h2 class="mb-3">Aktivni projekti</h2>
      <b-table
        id="projects-table"
        responsive="sm"
        hover
        :items="$store.getters['project/myProjects']"
        :fields="fields"
        stacked="md"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        sort-icon-left
        :busy="isLoading"
        :perPage="perPage"
        :currentPage="currentPage"
        show-empty
        empty-text="Trenutno nema aktivnih projekata"
      >
        <template v-slot:cell(title)="{ item }">
          <a href="#" @click.prevent="setProject(item.id)">{{ item.title }}</a>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner small class="align-middle mr-2"></b-spinner>
            <strong>Učitavanje...</strong>
          </div>
        </template>
        <template v-slot:cell(start_date)="{ item }">
          {{ item.start_date | moment('D.M.Y.') }} - {{ item.end_date | moment('D.M.Y.')}}
        </template>
        <template v-slot:empty="scope">
          <b-alert variant="warning" show>{{ scope.emptyText }}</b-alert>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        first-number
        last-number
        align="center"
        aria-controls="projects-table"
      ></b-pagination>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      sortBy: "start_date",
      stackedBr: "md",
      sortDesc: true,
      isLoading: true,
      currentPage: 1,
      perPage: 15,
      fields: [
        { key: "title", label: "Naziv", sortable: true },
        { key: "grant.name", label: "Grant", sortable: true },
        { key: "start_date", label: "Period", sortable: true }
      ]
    };
  },
  created() {
    this.$store
      .dispatch("project/myProjects")
      .then()
      .catch(err => {
        console.log(err);
      })
      .then(() => {
        this.isLoading = false;
      });
  },
  computed: {
    rows: function() {
      return this.$store.getters["project/myProjects"].length;
    }
  },
  methods: {
    setProject(uuid) {
      this.$store.commit("project/SET_UUID", uuid);
      this.$store
        .dispatch("project/get")
        .then(() => {
          this.$router.push({ name: "project", params: { uuid } });
        })
        .catch();
    }
  }
};
</script>

<style>
</style>
